import { Styles } from 'neuraum-angus'

export const brandedStyles: Styles = {
  userBubbleStyle: {
    background: 'var(--colour-neutral-025)',
    color: 'var(--text-main-on-light)'
  },
  closeChatIconStyle: {
    display: 'inline-flex',
    height: '20px',
    width: '20px',
    color: 'var(--branding-contrast-color, var(--branding-font-color))',
    fill: 'var(--branding-contrast-color, var(--branding-font-color))',
    stroke: 'var(--branding-contrast-color, var(--branding-font-color))'
  },
  botOptionStyle: {
    backgroundColor: 'var(--branding-main-color, var(--colour-primary-600))',
    borderColor: 'var(--branding-main-color, var(--colour-primary-600))',
    color: 'var(--branding-font-color)',
    padding: '20px',
    boxShadow:
      '0 6px 18px -15px var(--box-shadow-first-shade), 0 5px 15px -5px var(--box-shadow-second-shade)',
    border: 'none',
    fontWeight: 'bold'
  },
  botOptionHoveredStyle: {
    boxShadow:
      '0 6px 12px -8px var(--box-shadow-first-shade), 0 5px 30px -5px var(--box-shadow-second-shade)',
    transform: 'translateY(-1px)',
    color: 'var(--branding-font-color)',
    backgroundColor: 'var(--branding-main-color, var(--colour-primary-600))',
    border: 'none',
    borderRadius: '15px',
    padding: '20px',
    fontWeight: 'bold'
  },
  botBubbleStyle: {
    background: 'var(--colour-neutral-025)',
    border: 'none',
    color: 'var(--text-main-on-light)',
    maxWidth: '85%'
  },
  headerStyle: {
    background: 'var(--branding-main-color)',
    color: 'var(--branding-contrast-color, var(--branding-font-color))',
    padding: '16px'
  },
  chatButtonStyle: {
    background: 'var(--branding-main-color)',
    height: '64px',
    borderRadius: '8px',
    width: 'auto',
    padding: '14px 24px'
  },
  chatWindowStyle: {
    paddingBottom: 0,
    height: 'calc(100vh - 64px)',
    bottom: '32px',
    right: '32px',
    maxHeight: '900px',
    backgroundColor: 'var(--colour-background-010)',
    boxShadow:
      '0 6px 8px -2px rgba(59, 71, 104, 0.3), 0 2px 4px -3px #3b4768, 0 2px 40px 0 rgba(59, 71, 104, 0.05)'
  },
  chatInputContainerStyle: {
    backgroundColor: 'var(--colour-background-010)',
    borderTop: '1px solid var(--colour-neutral-100)',
    padding: '16px 0 16px 16px'
  },
  chatInputAreaStyle: {
    padding: '4px',
    background: 'transparent',
    resize: 'none',
    maxHeight: '10ch',
    fontSize: '16px'
  },
  chatInputAreaFocusedStyle: {
    outlineColor: 'none',
    boxShadow: 'none'
  },
  sendButtonStyle: {
    display: 'flex',
    backgroundColor: 'transparent',
    boxShadow: 'none'
  },
  sendButtonHoveredStyle: {
    display: 'flex',
    backgroundColor: 'transparent',
    boxShadow: 'none'
  }
}

export const defaultStyles: Styles = {
  userBubbleStyle: {
    background: 'var(--colour-neutral-025)',
    color: 'var(--text-main-on-light)'
  },
  closeChatIconStyle: {
    display: 'inline-flex',
    height: '20px',
    width: '20px',
    color: 'var(--text-main-on-dark)',
    fill: 'var(--text-main-on-dark)',
    stroke: 'var(--text-main-on-dark)'
  },
  botOptionStyle: {
    backgroundColor: 'var(--colour-primary-600)',
    borderColor: 'var(--colour-primary-600)',
    color: 'var(--text-main-on-dark)',
    padding: '20px',
    boxShadow:
      '0 6px 18px -15px var(--box-shadow-first-shade), 0 5px 15px -5px var(--box-shadow-second-shade)',
    border: 'none',
    fontWeight: 'bold'
  },
  botOptionHoveredStyle: {
    boxShadow:
      '0 6px 12px -8px var(--box-shadow-first-shade), 0 5px 30px -5px var(--box-shadow-second-shade)',
    transform: 'translateY(-1px)',
    color: 'var(--text-main-on-dark)',
    backgroundColor: 'var(--colour-primary-600)',
    border: 'none',
    borderRadius: '15px',
    padding: '20px',
    fontWeight: 'bold'
  },
  botBubbleStyle: {
    background: 'var(--colour-neutral-025)',
    border: 'none',
    color: 'var(--text-main-on-light)',
    maxWidth: '85%'
  },
  headerStyle: {
    background: 'var(--colour-primary-600)',
    color: 'var(--text-main-on-dark)',
    padding: '16px'
  },
  chatButtonStyle: {
    background: 'var(--colour-primary-600)',
    color: 'var(--text-main-on-dark)',
    height: '64px',
    borderRadius: '8px',
    width: 'auto',
    padding: '14px 24px'
  },
  chatWindowStyle: {
    paddingBottom: 0,
    height: 'calc(100vh - 64px)',
    bottom: '32px',
    right: '32px',
    maxHeight: '900px',
    backgroundColor: 'var(--colour-background-010)',
    boxShadow:
      '0 6px 8px -2px rgba(59, 71, 104, 0.3), 0 2px 4px -3px #3b4768, 0 2px 40px 0 rgba(59, 71, 104, 0.05)'
  },
  chatInputContainerStyle: {
    backgroundColor: 'var(--colour-background-010)',
    borderTop: '1px solid var(--colour-neutral-100)',
    padding: '16px 0 16px 16px'
  },
  chatInputAreaStyle: {
    padding: '4px',
    background: 'transparent',
    resize: 'none',
    maxHeight: '10ch',
    fontSize: '16px'
  },
  chatInputAreaFocusedStyle: {
    outlineColor: 'none',
    boxShadow: 'none'
  },
  sendButtonStyle: {
    display: 'flex',
    backgroundColor: 'transparent',
    boxShadow: 'none'
  },
  sendButtonHoveredStyle: {
    display: 'flex',
    backgroundColor: 'transparent',
    boxShadow: 'none'
  }
}
